import { render } from "./SidebarComponent.vue?vue&type=template&id=1099cba2"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=1099cba2&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__